import { render, staticRenderFns } from "./channelEdit.vue?vue&type=template&id=34180f90&scoped=true"
import script from "./channelEdit.vue?vue&type=script&lang=js"
export * from "./channelEdit.vue?vue&type=script&lang=js"
import style0 from "./channelEdit.vue?vue&type=style&index=0&id=34180f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34180f90",
  null
  
)

export default component.exports